import React from "react";
import { ButtonEdit, ButtonDelete } from "../../common/Buttons";
import moment from "moment";
import { useSelector } from "react-redux";
import { IconDot } from "../../Layout/Icons";
import { colors } from "../../../utils/colors";

function TableColumnDocuments({ id, item, index, onEdit, onDelete, auth }) {
  const { order_shops } = useSelector((state) => state.options);

  const renderRole = () => {
    if (item.role == "admin") {
      return "Admin";
    } else if (item.role == "manager") {
      return "Manager";
    }
    return "";
  };

  const renderDelete = () => {
    if (item.deleted_at) return false;
    else if (auth.role == "admin") return true;
    else return false;
  };
  return (
    <tr className="align-middle tableColumn" key={index}>
      <td className="align-middle">{item.id}</td>
      <td className="align-middle">{item.email}</td>
      <td className="align-middle">{item.firstname}</td>
      <td className="align-middle">{item.lastname}</td>
      <td className="align-middle">
        <div>New: {item.user_role?.title}</div>
        <div>Old: {renderRole()}</div>
      </td>
      <td className="align-middle">
        {item.deleted_at
          ? moment(item.deleted_at).format("YYYY-MM-DD HH:mm")
          : ""}
      </td>
      <td className="align-middle">
        {item?.user_role?.shop_ids && order_shops.map(({ value, label }) => (
          <React.Fragment key={value}>
            {label.includes("TR") && <hr className="my-1" />}
            <div className="flex align-items-center">
              <IconDot
                color={
                  item.user_role.shop_ids.includes(value)
                    ? colors["success"]
                    : colors["danger"]
                }
              />
              <span>{label}</span>
            </div>
          </React.Fragment>
        ))}
      </td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonEdit id={item.id} onEdit={() => onEdit("edit", item)} />
      </td>
      <td className="align-middle" style={{ width: "50px" }}>
        {renderDelete() && <ButtonDelete onDelete={() => onDelete(id)} />}
      </td>
    </tr>
  );
}

export default TableColumnDocuments;
